import { Button, Flex, Modal, Text } from "@mantine/core";

interface IDraftAutoSaveModal {
  opened: boolean;
  close: () => void;
  fetchNewEntry: () => void;
  fullName: string;
  dateCreated: string;
}

const AutoSaveModal = ({
  opened,
  close,
  fetchNewEntry,
  fullName,
  dateCreated,
}: IDraftAutoSaveModal) => {
  const handleYes = () => {
    close();
  };

  const handleNo = () => {
    fetchNewEntry();
    close();
  };

  return (
    <Modal
      onClose={close}
      withCloseButton={false}
      yOffset={"20dvh"}
      size={"lg"}
      opened={opened}
      title="New Entry">
      <Flex direction={"column"} gap={30}>
        <Text mt={15} align="center" color="#228BE6">
          You have an existing draft entry. If you want to keep this entry,
          please select Yes and then click Save.
        </Text>
        <Text align="center" color="#C92A2A">
          If you want to start a new draft, please select No and create a new
          entry.
        </Text>
        <Text mt={15} align="center">
          Draft entry was created by {fullName} on {dateCreated}
        </Text>
      </Flex>

      <Flex w={"100%"} justify={"center"} gap={10} mt={20}>
        <Button onClick={handleYes} color="blue" w={80}>
          Yes
        </Button>
        <Button onClick={handleNo} color="red" w={80}>
          No
        </Button>
      </Flex>
    </Modal>
  );
};

export default AutoSaveModal;
